module.exports = __webpack_public_path__ + "img/color_block_12.ec87cafd.svg";